var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMassMessages = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46821",
    "data-name": "Path 46821",
    d: "M4.971,1.52A1.228,1.228,0,0,0,3.758,2.761V8.316A1.228,1.228,0,0,0,4.971,9.557h2.5l1.716,2.5,1.716-2.5h2.5a1.194,1.194,0,0,0,.858-.364,1.26,1.26,0,0,0,.209-.286c.009-.018.018-.035.027-.054a1.167,1.167,0,0,0,.046-.111c.007-.019.013-.038.019-.057a1.29,1.29,0,0,0,.055-.369V2.761a1.236,1.236,0,0,0-.006-.127,1.27,1.27,0,0,0-.048-.242c-.006-.019-.012-.039-.019-.057-.014-.038-.029-.075-.046-.111-.009-.018-.017-.036-.027-.054a1.232,1.232,0,0,0-.209-.286l-.042-.041c-.029-.027-.059-.052-.09-.076a1.081,1.081,0,0,0-.1-.067h0l-.051-.03h0a1.2,1.2,0,0,0-.218-.094h0a1.157,1.157,0,0,0-.116-.03h0l-.059-.011h0l-.06-.008h0l-.062,0h0l-.062,0h0ZM1.9,11.089a.717.717,0,0,0-.709.725v3.519a.717.717,0,0,0,.709.725h1.46l1,1.462,1-1.462h1.46a.717.717,0,0,0,.709-.725V11.814a.717.717,0,0,0-.709-.725Zm9.657,0a.717.717,0,0,0-.709.725v3.519a.717.717,0,0,0,.709.725h1.46l1,1.462,1-1.462h1.46a.717.717,0,0,0,.709-.725V11.814a.717.717,0,0,0-.709-.725Z",
    transform: "translate(-1.187 -1.52)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMassMessages);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_massMessages.06caaf8c051ff3dfc28c4a1e0ee9d9dd.svg";